var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "modal-basic",
      staticClass: "modal",
      staticStyle: { display: "none" },
      attrs: { id: "modal-basic" },
    },
    [
      _c("div", { staticClass: "modal-inner" }, [
        _c("div", { staticClass: "modal-content modal-sm alert-pop" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "inner" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "btn-box full-1" }, [
                _c(
                  "button",
                  { staticClass: "btn btn-dark ok", attrs: { type: "button" } },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("common.confirm")) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-alert info" }, [
      _c("div", { staticClass: "text" }, [
        _c("p", [_c("strong", { staticClass: "modal-text" })]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }